<template>
  <div class="container">
    <el-container>
      <el-header class="header">
        <headers />
      </el-header>
      <el-container>
        <slider />
        <el-main>
          <div class="main_box">
            <div class="main_main">
              <!-- Page Header -->
              <div class="page_header">
                {{ pageTitle }}
              </div>
              <!-- Page Header -->

              <div class="page_main">
                <div class="form_box">
                  <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="0px"
                  >
                    <div v-if="!isEdit" class="btn_el">
                      <div class="tips">
                        Please select a user and assign the following module
                        management permissions. (Please ensure the user's
                        information has been completed before selection.)
                      </div>
                    </div>

                    <div class="input_el">
                      <div class="tit required">User</div>
                      <el-form-item label="" prop="uid">
                        <el-input
                          v-model="userName"
                          placeholder="Please select a user"
                          readonly
                          :disabled="isEdit"
                          @click.native="openUserDialog"
                        >
                          <i
                            slot="suffix"
                            class="el-input__icon el-icon-user"
                          ></i>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div v-if="!isEdit" class="desc_box">
                      <div class="desc_title">
                        Assign the module management permissions for this user:
                      </div>
                      <ul class="desc_list">
                        <li>
                          · System Management - Responsible for managing
                          companies, departments, users, roles, and permission
                          settings.
                        </li>
                        <li>
                          · Account Management - Authorized to create and edit
                          user accounts.
                        </li>
                        <li>
                          · Document Management - Responsible for configuring
                          the Document Control module. If no one is assigned to
                          this role, the System Administrator will manage the
                          module by default.
                        </li>
                        <li>
                          · CAPA - Responsible for configuring the CAPA module.
                          If no one is assigned to this role, the System
                          Administrator will manage the module by default.
                        </li>
                        <li>
                          · Training Management - Responsible for configuring
                          the Training Management module. If no one is assigned
                          to this role, the System Administrator will manage the
                          module by default.
                        </li>
                      </ul>
                    </div>
                    <div v-if="isEdit" class="desc_box">
                      <div class="desc_title">
                        Modify the assigned module management permissions for
                        this user:
                      </div>
                      <ul class="desc_list">
                        <li>
                          · System Management - Responsible for managing
                          companies, departments, users, roles, and permission
                          settings.
                        </li>
                        <li>
                          · Account Management - Authorized to create and edit
                          user accounts.
                        </li>
                        <li>
                          · Document Management - Responsible for configuring
                          the Document Control module. If no one is assigned to
                          this role, the System Administrator will manage the
                          module by default.
                        </li>
                        <li>
                          · CAPA - Responsible for configuring the CAPA module.
                          If no one is assigned to this role, the System
                          Administrator will manage the module by default.
                        </li>
                        <li>
                          · Training Management - Responsible for configuring
                          the Training Management module. If no one is assigned
                          to this role, the System Administrator will manage the
                          module by default.
                        </li>
                      </ul>
                    </div>
                    <div class="input_el">
                      <div class="tit">System Management</div>
                      <el-form-item label="" prop="system">
                        <el-select
                          v-model="ruleForm.system"
                          placeholder="Please select"
                          style="width: 100%"
                        >
                          <el-option label="Yes" :value="1"></el-option>
                          <el-option label="No" :value="2"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>

                    <div class="input_el">
                      <div class="tit">Account Management</div>
                      <el-form-item label="" prop="users">
                        <el-select
                          v-model="ruleForm.users"
                          placeholder="Please select"
                          style="width: 100%"
                        >
                          <el-option label="Yes" :value="1"></el-option>
                          <el-option label="No" :value="2"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>

                    <div class="input_el">
                      <div class="tit">Document Management</div>
                      <el-form-item label="" prop="documents">
                        <el-select
                          v-model="ruleForm.documents"
                          placeholder="Please select"
                          style="width: 100%"
                        >
                          <el-option label="Yes" :value="1"></el-option>
                          <el-option label="No" :value="2"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>

                    <div class="input_el">
                      <div class="tit">CAPA Management</div>
                      <el-form-item label="" prop="capa">
                        <el-select
                          v-model="ruleForm.capa"
                          placeholder="Please select"
                          style="width: 100%"
                        >
                          <el-option label="Yes" :value="1"></el-option>
                          <el-option label="No" :value="2"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>

                    <div class="input_el">
                      <div class="tit">Training Management</div>
                      <el-form-item label="" prop="train">
                        <el-select
                          v-model="ruleForm.train"
                          placeholder="Please select"
                          style="width: 100%"
                        >
                          <el-option label="Yes" :value="1"></el-option>
                          <el-option label="No" :value="2"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </el-form>
                </div>

                <div class="btn_box">
                  <van-button
                    class="btn_el"
                    type="default"
                    round
                    @click="cancel"
                  >
                    Cancel
                  </van-button>

                  <van-button
                    class="btn_el"
                    round
                    color="linear-gradient(to right, #7BC1FF, #4886FF)"
                    @click="submitForm('ruleForm')"
                  >
                    Save
                  </van-button>
                </div>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>

    <!-- User Selection Dialog -->
    <UserSelect
      :visible.sync="dialogVisible"
      :user-list="userList"
      :selected-id="selectedId"
      @confirm="handleConfirm"
    />
    <!-- User Selection Dialog -->
  </div>
</template>

<script>
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import UserSelect from "@/component/user-select.vue";
import {
  authRuleAdd,
  authRuleEdit,
  authRuleDetail,
} from "../../../api/system/config";
import { usersList } from "../../../api/system/user";

export default {
  components: {
    headers,
    slider,
    UserSelect,
  },
  data() {
    return {
      isEdit: false,
      oid: "",
      pageTitle: "",
      userName: "",
      dialogVisible: false,
      query: {
        user_id: "",
        username: "",
        status: "",
        company_id: "",
        departments_id: "",
        page: 1,
        page_size: 999999999,
      },
      userList: [],
      selectedId: null,
      selectedUser: null,
      ruleForm: {
        uid: "",
        system: 2,
        users: 2,
        capa: 2,
        documents: 2,
        train: 2,
      },
      rules: {
        uid: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        system: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        users: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        capa: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        documents: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
        train: [
          {
            required: true,
            message: "Please select",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    let that = this;
    that.oid = that.$route.query.oid || "";
    const row = that.$route.query.obj
      ? JSON.parse(decodeURIComponent(that.$route.query.obj))
      : null;
    if (that.oid && row) {
      that.isEdit = true;
      that.pageTitle = "Edit User Permissions";
      that.userName = row.user_id || "";
      that.ruleForm = {
        uid: row.uid || "",
        system: row.system,
        users: row.users,
        capa: row.capa,
        documents: row.documents,
        train: row.train,
      };
    } else {
      that.isEdit = false;
      that.pageTitle = "Assign User Permissions";
      that.resetFormData();
    }
    that.getUserList();
  },
  mounted() {
    let that = this;
  },
  watch: {
    //
  },
  methods: {
    getUserList() {
      let that = this;
      usersList(that.query).then((res) => {
        if (res.code == 200) {
          that.userList = res.data.data;
        }
      });
    },
    openUserDialog() {
      let that = this;
      if (that.isEdit) return;
      that.dialogVisible = true;
    },
    resetFormData() {
      let that = this;
      that.userName = "";
      that.selectedId = null;
      that.ruleForm = {
        uid: "",
        system: 2,
        users: 2,
        capa: 2,
        documents: 2,
        train: 2,
      };
    },
    handleConfirm({ id, user }) {
      let that = this;
      that.selectedId = id || null;
      that.ruleForm.uid = id || null;
      that.userName = user ? user.username : "";
      //请求用户权限详情
      authRuleDetail({ uid: that.ruleForm.uid }).then((res) => {
        if (res.code == 200) {
          that.ruleForm.system = res.data.system;
          that.ruleForm.users = res.data.users;
          that.ruleForm.capa = res.data.capa;
          that.ruleForm.documents = res.data.documents;
          that.ruleForm.train = res.data.train;
        }
      });
    },
    //取消
    cancel() {
      let that = this;
      that.$router.back();
    },
    //保存
    submitForm(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            uid: that.ruleForm.uid,
            system: that.ruleForm.system,
            users: that.ruleForm.users,
            capa: that.ruleForm.capa,
            documents: that.ruleForm.documents,
            train: that.ruleForm.train,
          };
          // 编辑
          if (that.isEdit) {
            authRuleEdit({
              id: that.oid,
              ...params,
            }).then(() => {
              that.$message.success("Operation successful");
              that.$router.back();
            });
          } else {
            // 新增
            authRuleAdd(params).then(() => {
              that.$message.success("Operation successful");
              that.$router.back();
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_box {
      text-align: center;
      .btn_el {
        margin-left: 10px;
        padding: 12px 24px;
        .van-button__text {
          font-size: 16px;
        }
      }
    }
    .form_box {
      .input_el {
        .tit {
          padding-bottom: 5px;
          font-size: 14px;
          color: #333333;
        }
        .required::before {
          content: "*";
          color: red;
          margin-right: 2px;
        }
      }
    }
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }

  // 说明区域
  .desc_box {
    margin: 10px 0 20px 0;
    padding: 6px 8px;
    background-color: #ffb1001a;
    border-radius: 6px;
    color: #333;

    .desc_title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .desc_list {
      margin: 0;
      padding-left: 20px;

      li {
        line-height: 28px;
        font-size: 14px;
      }
    }
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}
</style>

